module.exports = __webpack_public_path__ + "static/media/42.a6325af9.png";